import { EmailIconResetPassword } from "./ForgotPasswordModel.styled";

export const EmailUserIconPassword = () => {
  return (
    <>
      <EmailIconResetPassword
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M26.667 5.333h-21.333c-1.467 0-2.653 1.2-2.653 2.667l-0.013 16c0 1.467 1.2 2.667 2.667 2.667h21.333c1.467 0 2.667-1.2 2.667-2.667v-16c0-1.467-1.2-2.667-2.667-2.667zM26.667 10.667l-10.667 6.667-10.667-6.667v-2.667l10.667 6.667 10.667-6.667v2.667z" />
      </EmailIconResetPassword>
    </>
  );
};
